import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent } from '@core/user-interface-legacy';

import { MainViewEntityActions } from '../../../features/main-view/data/store/main-view.store';

@Component({
  selector: 'rtr-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent, RouterLink, RouterLinkActive, TranslatePipe],
})
export class SidebarComponent {
  private readonly store = inject(Store);
  public logOut = output<void>();

  private ngOnDestroy$ = new Subject<void>();

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public closeSidebar(): void {
    this.store.dispatch(MainViewEntityActions.toggleSidebar());
  }
}
